import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'withdraw-invitation',
  templateUrl: './withdraw-invitation.component.html',
  styleUrls: ['./withdraw-invitation.component.scss']
})
export class WithdrawInvitationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
